exports = module.exports = require("../../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".videoContainer_3XYyNrsH {\n  position: relative;\n  overflow: hidden;\n}\n\n.containerMargin_3dikTDrF {\n  width: unset !important;\n  margin: 0 0.346667rem;\n}", ""]);

// exports
exports.locals = {
	"videoContainer": "videoContainer_3XYyNrsH",
	"containerMargin": "containerMargin_3dikTDrF"
};